import { Tab, PrevNext } from 'pages/iDNA3ToOne/Common';
import React from 'react';
import { blueColor, nutriGenetixCards } from './NutriGenetix';

const NutriGenetixDND = () => {
  const tab = {
    color: blueColor,
    id: 'nutriGenetix',
    title: 'iDNA NutriGenetix',
  };

  return (
    <div>
      <Tab tab={ tab } />
      <PrevNext options={ nutriGenetixCards } isNutrition activePage='nutriGenetixDVD' />
    </div>
  );
};

export default NutriGenetixDND;
